import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseReward } from "@models/reward.model";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: "root",
})
export class RewardsService {
    constructor(private http: HttpClient) {}

    public getRewardsWithTotalCountForUser(
        userId: number,
        pageIndex: number = environment.dynamicPagination.pageIndex,
        pageSize: number = environment.dynamicPagination.pageSize,
    ): Observable<{
        count: number;
        rows: BaseReward[];
        balance: number;
    }> {
        return this.http.get<{
            count: number;
            rows: BaseReward[];
            balance: number;
        }>(
            `${environment.apiUrlBasePath}/reward/getReward?pageIndex=${pageIndex}&pageSize=${pageSize}&userId=${userId}`,
        );
    }
}
